/* eslint-disable import/prefer-default-export */
export const renderOnCondition = (condition, content) => condition && content();
